import React, { useEffect, useState } from "react";
import "./App.css";
import "./admin.css"; // Import admin styles
import Faq from "./Components/Faq";
import Footer from "./Components/Footer";
import Navbar from "./Components/Navbar";
import Topbar from "./Components/Topbar";
import Careers from "./Components/Careers";
import Bookings from "./Components/Bookings";
import Articles from "./Components/Articles";
import Prices from "./Components/Prices";
import Loader from "./Components/Loader";
import AdminLayout from "./Components/Admin/AdminLayout";
import AdminAuth from "./Components/Admin/AdminAuth";
import ContentManager from "./Components/Admin/ContentManager";
import ServicesManager from "./Components/Admin/ServicesManager";
import TeamManager from "./Components/Admin/TeamManager";
import LocationManager from "./Components/Admin/LocationManager";
import PricesManager from "./Components/Admin/PricesManager";
import FAQManager from "./Components/Admin/FAQManager";
import BookingsManager from "./Components/Admin/BookingsManager";
// ⚠️ COMMENTED OUT - Dangerous components removed from production
// import MigrationRunner from "./Components/Admin/MigrationRunner";
// import ImageUploader from "./Components/Admin/ImageUploader";
import ArticlesManager from "./Components/Admin/ArticlesManager";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Home } from "./pages/Home";
import { imageUrls } from "./lib/supabase";
// ⚠️ COMMENTED OUT - Migration no longer needed in production
// import {
//   runMigration,
//   checkMigrationStatus,
// } from "./migration/contentMigration";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [shouldShowLoader, setShouldShowLoader] = useState(false);

  // Check if loader should be shown today
  const checkLoaderStatus = () => {
    try {
      const lastShown = localStorage.getItem('loaderLastShown');
      const today = new Date().toDateString();
      return !lastShown || lastShown !== today;
    } catch (error) {
      return true; // Show loader if localStorage not available
    }
  };

  useEffect(() => {
    const shouldShow = checkLoaderStatus();
    setShouldShowLoader(shouldShow);

    if (!shouldShow) {
      // If loader shouldn't show, immediately set loading to false
      setIsLoading(false);
      return;
    }

    // Only run image preloading if loader should show
    // Create an array of key images to preload
    const images = [
      imageUrls.mainHeaderLogo(), // Header background
      // Add other critical images here if needed
    ];

    // Track loaded images
    let loadedImages = 0;

    // Preload all critical images
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        loadedImages++;
        // When all critical images are loaded or after timeout, hide loader
        if (loadedImages === images.length) {
          setTimeout(() => setIsLoading(false), 1000); // Minimum 1 second of loader
        }
      };
      img.onerror = () => {
        loadedImages++; // Count errors too to avoid blocking
        if (loadedImages === images.length) {
          setTimeout(() => setIsLoading(false), 1000);
        }
      };
    });

    // Fallback timeout in case some images fail to load
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 4000); // Maximum 4 seconds of loader

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <div className="app-wrapper">
        {shouldShowLoader && <Loader isLoading={isLoading} />}
        {!isLoading && (
          <Routes>
            {/* Admin Routes - No Topbar/Navbar/Footer */}
            <Route
              path="/admin/*"
              element={
                <AdminAuth>
                  <AdminLayout>
                    <Routes>
                      <Route
                        path="dashboard"
                        element={<div>Dashboard Coming Soon</div>}
                      />
                      <Route path="bookings" element={<BookingsManager />} />
                      <Route path="content" element={<ContentManager />} />
                      <Route path="services" element={<ServicesManager />} />
                      <Route path="team" element={<TeamManager />} />
                      <Route path="locations" element={<LocationManager />} />
                      <Route path="prices" element={<PricesManager />} />
                      <Route path="articles" element={<ArticlesManager />} />
                      <Route path="faq" element={<FAQManager />} />
                      {/* ⚠️ COMMENTED OUT - Dangerous routes removed from production */}
                      {/* <Route
                        path="images"
                        element={<ImageUploader />}
                      /> */}
       
                      {/* <Route path="migration" element={<MigrationRunner />} /> */}
                      <Route path="" element={<BookingsManager />} />
                    </Routes>
                  </AdminLayout>
                </AdminAuth>
              }
            />

            {/* Public Routes - With Topbar/Navbar/Footer */}
            <Route
              path="/*"
              element={
                <>
                  <Topbar />
                  <Navbar />
                  <Routes>
                    <Route exact path="/" element={<Home />} />
                    <Route exact path="/faq" element={<Faq />} />
                    <Route exact path="/cariere" element={<Careers />} />
                    <Route exact path="/rezervări" element={<Bookings />} />
                    <Route exact path="/articole" element={<Articles />} />
                    <Route exact path="/articole/:slug" element={<Articles />} />
                    <Route exact path="/prețuri" element={<Prices />} />
                  </Routes>
                  <Footer />
                </>
              }
            />
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;
